import { supabase } from './supabase';
import { User } from '../types/auth';

export const adminService = {
  async getAllUsers(): Promise<User[]> {
    const { data, error } = await supabase.from('users').select('*');

    if (error) {
      throw new Error(error.message);
    }

    return data as User[];
  },

  async addTokensToUser(userId: string, amount: number): Promise<void> {
    const { error } = await supabase.rpc('add_tokens_to_user', {
      user_id_input: userId,
      token_amount: amount,
    });

    if (error) {
      throw new Error(error.message);
    }
  },

  async getAllGenerations(): Promise<any[]> {
    const { data, error } = await supabase
      .from('moodboard_generations')
      .select(`
        *,
        users (
          email
        )
      `);

    if (error) {
      throw new Error(error.message);
    }

    return data;
  },
}; 